import React from 'react';
import { motion } from 'framer-motion';
import { Eye, MapPin, ClipboardList, Play } from 'lucide-react';
export const RutaSystem = () => {
  const steps = [{
    letter: 'R',
    word: 'Reconoce',
    desc: 'Señales que importan vs ruido (6 áreas clave) con ejemplos reales “en casa”.',
    icon: Eye,
    color: 'bg-blue-100 text-blue-600'
  }, {
    letter: 'U',
    word: 'Ubica',
    desc: 'Qué cambia a los 18 vs 24 meses (cuándo vigilar y cuándo actuar).',
    icon: MapPin,
    color: 'bg-teal-100 text-teal-600'
  }, {
    letter: 'T',
    word: 'Tracking',
    desc: '5 minutos al día. Registro simple que se entiende en consulta (7 días).',
    icon: ClipboardList,
    color: 'bg-amber-100 text-amber-600'
  }, {
    letter: 'A',
    word: 'Acción',
    desc: 'Pediatra → Early Intervention → próximos pasos, con guiones listos (14 días).',
    icon: Play,
    color: 'bg-coral-100 text-[#E8734A]' // Custom coral class approximation
  }];
  return <section className="w-full bg-white py-20 px-4 md:py-28" data-id="element-142">
      <div className="max-w-5xl mx-auto" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B2A4A] mb-4" data-id="element-145">
            El Sistema RUTA
          </h2>
          <p className="text-lg text-[#2D3436]/80" data-id="element-146">
            La Ruta Clara funciona porque no es solo “contenido”. Es un
            mecanismo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-147">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="relative p-6 rounded-2xl border border-gray-100 bg-[#FFF9F3] hover:shadow-lg transition-all duration-300" data-id="element-148">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${step.color.includes('coral') ? 'bg-[#E8734A]/10 text-[#E8734A]' : step.color}`} data-id="element-149">
                <step.icon className="w-6 h-6" data-id="element-150" />
              </div>
              <div className="flex items-baseline space-x-2 mb-2" data-id="element-151">
                <span className="text-4xl font-black text-[#1B2A4A]/10" data-id="element-152">
                  {step.letter}
                </span>
                <h3 className="text-xl font-bold text-[#1B2A4A]" data-id="element-153">
                  {step.word}
                </h3>
              </div>
              <p className="text-[#2D3436] text-sm leading-relaxed" data-id="element-154">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};